import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { DOMAIN, SSAE, SSLE, SSPC, SSPE, SSSB } from '../../Constants/base';
import { postReq } from '../../utils/api';
import PCIcon from '../../assets/PC1.svg';
import PEIcon from '../../assets/pe02.svg';
import LEIcon from '../../assets/le02.svg';
import AEIcon from '../../assets/ae02.svg';
import SSSBIcon from '../../assets/sssb.png';
import StackBundle from '../../assets/sb-small.svg';
import SSButton from '../SSButton';
import { CurrentUserDetails } from '../../context';
import { trackEvents } from '../../utils/analytics';
import { epochToJsDate, getSessionStorage, setSessionStorage } from '../../utils';

export default function SSAppStatus({ isTrialMode, plan, getUserPlans, setOpenPCPopup, pcPlanRef, sbActivated }) {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales'));
  const [showLoader, setShowLoader] = useState(false);
  const [profile] = useContext(CurrentUserDetails);
  const profilesSession = getSessionStorage('current-profile');
  const [disableButton, setDisableButton] = useState(false);

  const getImage = (type) => {
    if (type === 'lead_engager') return LEIcon;
    else if (type === 'pro_caller') return PCIcon;
    else if (type === 'audience_engager') return AEIcon;
    else if (type === 'pro_emailer') return PEIcon;
    else return SSSBIcon;
  };

  const subscribeToProduct = async (plan) => {
    if (showLoader) return;
    let itemObj = {
      item_id: plan.product.id,
      item_name: plan.product.nickName,
      price: plan.product.price,
      quantity: 1,
    };
    setShowLoader(true);
    let url = `${DOMAIN}/v1/stripe/user/create-checkout-session`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    let payload = {
      productId: plan.product.id,
    };
    const response = await postReq({ url, requestHeaders, payload });
    const { code, data, message } = response;
    if (code === 200 && data.url) {
      setSessionStorage({
        key: 'product-info',
        value: {
          userId: profilesSession.userId,
          items: itemObj,
          currency: plan.product.currency,
          value: plan.product.price,
        },
      });
      window.location.replace(data.url);
      setShowLoader(false);
    } else if (code === 200 && data.message) {
      trackEvents('purchase', {
        userId: profilesSession.userId,
        items: itemObj,
        currency: plan.product.currency,
        value: plan.product.price,
      });
      //GTM event
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

      window.dataLayer.push({
        event: 'purchase',
        user_id: profilesSession.userId,
        type: 'individual',
        ecommerce: {
          currency: plan.product.currency,
          value: plan.product.price,
          items: [
            {
              item_id: plan.product.id,
              item_name: plan.product.nickName,
              price: plan.product.price,
              discount: 0.0,
              quantity: 1,
            },
          ],
        },
      });

      toast.success(data.message, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setShowLoader(false);
      getUserPlans();
    } else if (code !== 200 && message) {
      toast.error(message, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setShowLoader(false);
    }
  };

  const getPlanText = (plan) => {
    if (plan.product.cancelAtPeriodEnd) return <span>PLAN ENDS ON {epochToJsDate(plan.end)}</span>;
    return <span>PLAN RENEWS ON {epochToJsDate(plan.end)}</span>;
  };

  const getToolStatus = (plan) => {
    return (
      <div className="plan-cost">
        {plan.product.nickName === SSSB && <span className="title">Bundle Price</span>}

        <div
          translate="no"
          className="cost"
          style={{
            opacity: plan.hasActiveSubscription ? '1' : '0.4',
          }}
        >
          {isTrialMode && plan.product.nickName === SSSB ? (
            <span>Free Trial</span>
          ) : isTrialMode && plan.product.nickName !== SSSB ? (
            <span></span>
          ) : plan.product.nickName !== SSSB && sbActivated ? (
            <span></span>
          ) : (
            <span>{`$${plan.product.price} / mth`}</span>
          )}
        </div>
        <div
          translate="no"
          className="plan-expire"
          style={{
            color: plan.product.cancelAtPeriodEnd ? '#FFB800' : '#fff',
          }}
        >
          {(sbActivated || isTrialMode) && plan.product.nickName !== SSSB
            ? ''
            : plan?.hasActiveSubscription && plan.end
            ? getPlanText(plan)
            : ''}
        </div>
      </div>
    );
  };

  const getBtnTitle = (plan) => {
    return plan?.hasActiveSubscription || isTrialMode ? 'UNSUBSCRIBE' : 'SUBSCRIBE';
  };

  const getBtnType = (plan) => {
    return plan.hasActiveSubscription ? 'outline' : isTrialMode || plan?.hasActiveSubscription ? 'outline' : 'filled';
  };

  const getBtnDisabled = (plan) => {
    return plan?.hasActiveSubscription || isTrialMode ? false : profile.roleType !== 'OWNER' ? true : false;
  };

  const checkSubscription = (currentPlan) => ['UNLIMITED', 'TRIAL'].includes(currentPlan);

  const handleToolBtnClick = (plan) => {
    let itemObj = {
      item_id: plan.product.id,
      item_name: plan.product.nickName,
      price: plan.product.price,
      quantity: 1,
    };
    if (plan.product.nickName === SSPC && (isTrialMode || plan?.hasActiveSubscription)) {
    } else {
      trackEvents('begin_checkout', {
        userId: profilesSession.userId,
        items: itemObj,
        currency: plan.product.currency,
        value: plan.product.price,
      });
      //GTM event
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'begin_checkout',
        user_id: profilesSession.userId,
        ecommerce: {
          currency: plan.product.currency,
          value: plan.product.price,
          items: [
            {
              item_id: plan.product.id,
              item_name: plan.product.nickName,
              price: plan.product.price,
              discount: 0.0,
              quantity: 1,
            },
          ],
        },
      });

      subscribeToProduct(plan);
    }
  };

  return (
    <div className={plan.product.nickName === SSSB ? 'active-plan-sssb active-plan' : 'active-plan'}>
      <div className="tool">
        <div
          className="icon"
          style={{
            minHeight: plan.product.nickName === SSSB ? '80px' : '60px',
            minWidth: plan.product.nickName === SSSB ? '80px' : '60px',
            marginRight: plan.product.nickName === SSSB ? '30px' : '0px',
          }}
        >
          <img
            src={getImage(plan.product.nickName.toLowerCase())}
            alt=""
            style={{
              transform: plan.product.nickName === SSSB ? 'scale(1.4)' : 'scale(1)',
            }}
          />
        </div>
        <div className="details">
          <div className="tool-name">{plan.product.name}</div>
          {plan.product.nickName !== SSSB ? (
            <div className="tool-desc">{plan.product.description}</div>
          ) : (
            <div className="tool-icons">
              <img src={LEIcon} alt="" />
              <img src={AEIcon} alt="" />
              <img src={PEIcon} alt="" />
              <img src={PCIcon} alt="" />
            </div>
          )}

          <div className="tool-flex-cost">
            <div className="plan-cost">
              <span className="title">Total</span>
              <div translate="no" className="cost">
                <span
                  style={{
                    textDecoration: 'line-through',
                    color: '#24FF00',
                  }}
                >
                  {plan.product.originalPrice}
                </span>
              </div>
            </div>

            {getToolStatus(plan)}
          </div>
          {/* <div className="end-note">SUBSCRIPTION ENDING 01.01.2023 </div> */}
        </div>
        <div className="ss-cta">
          {plan.hasActiveSubscription ? (
            <form
              method="POST"
              action={`${DOMAIN}/v1/stripe/customer-portal`}
              onSubmit={(e) => {
                if (disableButton) e.preventDefault();
                else {
                  setDisableButton(true);
                }
              }}
            >
              <input
                style={{ display: 'none' }}
                name="accessToken"
                id="accessToken"
                defaultValue={userToken?.accessToken ? `${userToken?.accessToken}` : `${userToken}`}
                hidden
              />

              <SSButton
                classBtn={'unsub-btn instal-btn'}
                type={'outline'}
                btnText={getBtnTitle(plan)}
                isDisabled={disableButton}
              ></SSButton>
            </form>
          ) : (
            <SSButton
              btnText={getBtnTitle(plan)}
              type={getBtnType(plan)}
              classBtn={
                plan?.hasActiveSubscription
                  ? plan.product.nickName === SSSB
                    ? 'hide-btn'
                    : 'instal-btn'
                  : 'instal-btn'
              }
              showLoader={showLoader}
              onClickHandle={() => {
                handleToolBtnClick(plan);
              }}
              isDisabled={getBtnDisabled(plan)}
            />
          )}
        </div>
      </div>
      <div
        className="tool-more"
        style={{
          paddingRight: plan.product.nickName === SSSB ? '0px' : '60px',
        }}
      >
        {plan.product.nickName === SSSB && (
          <div className="tool-flex-cost">
            <div className="plan-cost">
              <span className="title">Total</span>
              <div translate="no" className="cost">
                <span
                  style={{
                    textDecoration: 'line-through',
                    color: '#24FF00',
                  }}
                >
                  {plan.product.originalPrice}
                </span>
              </div>
            </div>
          </div>
        )}
        <div className="tool-flex-cost">{getToolStatus(plan)}</div>
        {sbActivated && plan.product.nickName !== SSSB ? (
          <div
            style={{
              fontWeight: '300',
              color: '#c4c4c4',
            }}
          >
            Included in Bundle
          </div>
        ) : plan.hasActiveSubscription ? (
          <form
            method="POST"
            action={`${DOMAIN}/v1/stripe/customer-portal`}
            onSubmit={(e) => {
              if (disableButton) e.preventDefault();
              else {
                setDisableButton(true);
              }
            }}
          >
            <input
              style={{ display: 'none' }}
              name="accessToken"
              id="accessToken"
              defaultValue={userToken?.accessToken ? `${userToken?.accessToken}` : `${userToken}`}
              hidden
            />

            <SSButton
              classBtn={'unsub-btn instal-btn'}
              type={'outline'}
              btnText={getBtnTitle(plan)}
              isDisabled={disableButton}
            ></SSButton>
          </form>
        ) : (
          <SSButton
            btnText={getBtnTitle(plan)}
            type={getBtnType(plan)}
            classBtn={plan?.hasActiveSubscription ? 'unsub-btn instal-btn' : 'instal-btn'}
            showLoader={showLoader}
            onClickHandle={() => {
              handleToolBtnClick(plan);
            }}
            isDisabled={getBtnDisabled(plan)}
          />
        )}
      </div>
      <div className="mob-details">
        <div className="tool-name">{plan.product.name}</div>
        <div className="tool-desc">{plan.product.description}</div>

        <div className="tool-flex-cost">
          <div
            className="plan-cost"
            style={{
              marginRight: '16px',
            }}
          >
            <span className="title">Total</span>
            <div translate="no" className="cost">
              <span
                style={{
                  textDecoration: 'line-through',
                  color: '#24FF00',
                }}
              >
                {plan.product.originalPrice}
              </span>
            </div>
          </div>
          {getToolStatus(plan)}
        </div>
        {/* <div className="end-note">SUBSCRIPTION ENDING 01.01.2023 </div> */}
      </div>
    </div>
  );
}
